var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"plain":"","color":"primary","exact":"","to":_vm.Route}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-pencil")]),_vm._v("Edit ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }